<app-loader *ngIf="isLoading"></app-loader>
<div class="d-none d-md-block">
  <div class="d-flex flex-wrap align-items-center mb-3 topHeading">
    <div class="me-2 userDevice-div" data-toggle="tooltip" title="manage devices">
      <div class="mb-0 fw-bold-new">
        {{'MANAGEDEVICE.MANAGEDEVICES' | translate }} / <span class="fw-normal">
          {{'MANAGEDEVICE.MANAGEDEVICECONTROLSTR' | translate }}</span>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-between flex-wrap align-items-center mt-1">
    <div class="d-flex justify-content-between align-items-center mb-2 d-none d-md-block">
      <div class="ms-2 d-flex align-items-center">
        <div class="mb-0 name">
          <span><img src="../../../assets/images/backarrow.png" (click)="goBack()" alt=""
              class="me-1 cursor-pointer" /></span>
          {{ deviceName }}
        </div>
      </div>
    </div>
    <div class="ms-auto mt-3 mt-md-0">
      <div class="date mx-4 mb-3 ms-5" *ngIf="userName != null">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-repeat"
          viewBox="0 0 16 16">
          <path
            d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41m-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9" />
          <path fill-rule="evenodd"
            d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5 5 0 0 0 8 3M3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9z" />
        </svg>
        {{'MANAGEDEVICE.DEVICELASTSYNCSTR' | translate }} {{ deviceLastSyncTime }}
      </div>
    </div>
  </div>
  <div class="date mx-4 mb-3 ms-5" *ngIf="userName != null">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person"
      viewBox="0 0 16 16">
      <path
        d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
    </svg>
    {{ currentUserName }}
    <div class="badge ms-1 text-xs text-center" [style.color]="privacyStatusClr"
      [style.background-color]="privacyStatusBg">
      {{ getLocalizationStringRole(currentUserRole) }}
    </div>
  </div>
</div>
<div class="row mt-3">
  <div class="col-12">
    <div class="mng-device-tabs position-relative">
      <div class="d-flex justify-content-between flex-wrap align-items-center mt-1">
        <div class="d-flex justify-content-between align-items-center mb-2 d-none d-md-block">
          <div class="ms-2 d-flex align-items-center">
            <div class="mb-0">
              <strong>{{'MANAGEDEVICE.SCREENTIMEDEVICECONTROLSTR' | translate }}</strong>
            </div>
          </div>
        </div>
        <div class="ms-auto mt-3 mt-md-0">
          <div class="parental-control-string-l mx-4 mb-3 ms-5" style="color: #526B77;
" *ngIf="userName != null">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle"
              viewBox="0 0 16 16">
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
              <path
                d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
            </svg>
            {{'MANAGEDEVICE.SCREENTIMEINFOSTR' | translate }}
          </div>
        </div>
      </div>

      <div *ngIf="openMyDeviceContent" class="tab-pane fade show active" id="tabs-home" role="tabpanel"
        aria-labelledby="tabs-home-tab">
        <div class="mx-auto w-100 relative d-none d-md-block" *ngIf="deviceControlsList?.length != 0">
          <div class="tab-content" id="pills-tabContent">
            <div class="tab-pane fade show active" role="tabpanel" aria-labelledby="pills-home-tab">
              <div class="d-flex mt-3 mb-3">
                <div [ngClass]="
                            selectedLanguage === 'it'
                              ? 'col-4'
                              : 'col-3'
                          ">
                  <nav id="">
                    <div
                      class="left-0 d-block fixed top-0 bottom-0 overflow-y-auto flex-row flex-nowrap overflow-hidden flex-column px-0 d-flex flex-wrap">
                      <ul class="flex-column min-w-100 d-flex list-unstyled me-3" id="pills-tabVertical">
                        <li *ngFor="let item of deviceControlsList; let i = index" (click)="selectedIndex(i, item)"
                          class="align-items-center cursor-pointer bg-white d-flex position-relative" [ngClass]="
                            selectedI === i
                              ? 'q-vertical-text-user-selected'
                              : 'q-vertical-text-user'
                          ">
                          <img
                            *ngIf="(item.name === 'Smart Parenting' || item.name === 'Youtube Supervision' || item.name === 'Theft & Intrusion Alert') && showPremium"
                            src="assets/images/vectorstar.svg" class="corner-image" alt="" />
                          <tab-title-inline>
                            <span title1>
                              <div class="d-flex justify-content-between">
                                <div class="q-tab-title ms-0" style="font-size: 16px" data-toggle="tooltip"
                                  title="{{ getLocalizationString(item.name) || 'N/A' }}">
                                  <span>
                                    <img src="./assets/images/{{item.prop}}.svg" class="me-2" alt="" srcset=""
                                      height="35px" />
                                  </span>
                                  {{ getLocalizationString(item.name) || 'N/A' }}
                                </div>
                              </div>
                            </span>
                          </tab-title-inline>
                          <div
                            *ngIf="!showPremium || item.name === 'Device Pin' || item.name === 'Theft % Instruction Alert' || item.name === 'Screentime'"
                            class="badge text-xs text-center" [style.background-color]="
                              item.toggleTurnOnOffStatus
                                ? toggleOn_bg_badge_clr
                                : toggleOff_bg_badge_clr
                            " [style.color]="
                              item.toggleTurnOnOffStatus
                                ? toggleOn_txt_color
                                : toggleOff_txt_color
                            " style="position: absolute; top: 5px; right: 5px">
                            {{ item.toggleTurnOnOffStatus ? "ON" : "OFF" }}
                          </div>
                        </li>
                      </ul>
                    </div>
                  </nav>
                </div>
                <div class="bg-white border-radius shadow-md" [ngClass]="
                            selectedLanguage === 'it'
                              ? 'col-8'
                              : 'col-9'
                          " style="margin-bottom: 30px;">
                  <div *ngIf="selctedTabType == 'smartParent'" class="ml-2rem">
                    <div class="col-md-12">
                      <ng-container *ngIf="showPremium">
                        <!-- Safe Browsing Toggle Section -->
                        <div class="mt-4">
                          <div class="d-flex justify-content-between mb-2">
                            <div class="d-flex align-items-center gap-3">
                              <h5 class="fw-bold">{{ "SETTINGS.safeBrowsing" | translate }}</h5>
                              <span>
                                <label class="switch">
                                  <input type="checkbox" id="safeBrowsingEnabled" [checked]="safeBrowsingEnabled"
                                    (change)="onSafeBrowserToggle($event)" />
                                  <span class="slider round"></span>
                                </label>
                              </span>
                            </div>
                            <div class="d-flex justify-content-between">
                              <div class="parental-control-string-l mx-4 mb-3 ms-5" style="color: #8C8C8C;"
                                *ngIf="userName != null">
                                {{'LASTUPDATED.LASTUPDATE' | translate }} {{ smartParentingLastSyncTime }}
                              </div>
                            </div>
                          </div>

                          <p class="parental-control-string-l mt-1">
                            {{ "SETTINGSMAIN.PREVENTHARMFULSITES" | translate }}
                          </p>
                          <hr style="margin-left: -32px" />
                        </div>
                        <div [ngClass]="{ 'disabled-yt-section': showPremium }">


                          <div class="d-flex justify-content-between">
                            <div class="d-flex align-items-center gap-3">
                              <h5 class="fw-bold">
                                {{ "SETTINGS.PARENTALCONTROL" | translate }}
                              </h5>
                              <span>
                                <label class="switch">
                                  <input type="checkbox" />
                                  <span class="slider round"></span>
                                </label>
                              </span>
                            </div>
                          </div>

                          <div>
                            <p class="mb-0 parental-control-string-l">
                              {{ "SETTINGS.SMARTPARANTINGTEXT" | translate }}
                            </p>
                          </div>
                        </div>


                        <div class="mt-4 bg-white p-3" style="border-radius: 12px;">
                          <div class="col-sm-12 relative">
                            <div class="pt-3">
                              <div class="mb-3 text-center">
                                <div class="mt-2">
                                  <span><img src="./assets/images/upgradeToPremium.svg" alt=""></span>
                                </div>
                                <div class="mt-2 pt-1 pb-1">
                                  <span *ngIf="status === 'Free version' || licenseValidity === 'Free version'"
                                    class="empty-report-text">{{
                                    "DASHBOARD.PREMIUMFEATUREUPGARDE" | translate }}</span>
                                  <span *ngIf="status === 'LICENSE_EXPIRED' || licenseValidity === 'LICENSE_EXPIRED'"
                                    class="empty-report-text"> {{
                                    "DASHBOARD.PREMIUMFEATURERENEW" | translate }} </span>
                                </div>
                                <div class="mt-2 pt-1">
                                  <button *ngIf="status === 'Free version' || licenseValidity === 'Free version'"
                                    (click)="navigateToRenew()"
                                    class="submit-btn bg-orgclr py-2 px-4 add-device shadow-none">
                                    {{ "LICENSESUMMARY.UPGRADE" | translate }}
                                  </button>
                                  <button *ngIf="status === 'LICENSE_EXPIRED' || licenseValidity === 'LICENSE_EXPIRED'"
                                    (click)="navigateToRenew()"
                                    class="submit-btn bg-orgclr py-2 px-4 add-device shadow-none">
                                    {{ "LICENSESUMMARY.RENEW" | translate }}
                                  </button>
                                </div>

                                <div class="mt-2 pt-1 d-flex justify-content-center">
                                  <div class="pt-4"
                                    *ngIf="status === 'Free version'  || licenseValidity === 'Free version'">
                                    <div class=" p-4 expiry-text-background-color border premium-box text-start">
                                      <div>
                                        <span class="font-weight-600">
                                          {{ "SETTINGS.PARENTALSETTINGPRIMESTRING" | translate}}
                                        </span>
                                      </div>
                                      <div class="mt-1">
                                        <span>
                                          {{ "SETTINGS.PARENTALSETTINGPRIMESUBSTRING" | translate}}
                                        </span>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="pt-4"
                                    *ngIf="status === 'LICENSE_EXPIRED'  || licenseValidity === 'LICENSE_EXPIRED'">
                                    <div class="text-start p-4 m-4 expiry-text-background-color border premium-box">
                                      <div>
                                        <span class="font-weight-600">
                                          {{ "SETTINGS.PARENTALSETTINGPRIMESTRING" | translate}}
                                        </span>
                                      </div>
                                      <div class="mt-1">
                                        <span>
                                          {{ "SETTINGS.PARENTALSETTINGPRIMERENEWSUBSTRING" | translate}}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </div>


                    <div class="mb-4 mt-4" *ngIf="!showPremium">

                      <!-- Safe Browsing Toggle Section -->
                      <div class="mt-4">
                        <div class="d-flex justify-content-between mb-2">
                          <div class="d-flex align-items-center gap-3">
                            <h5 class="fw-bold">{{ "SETTINGS.safeBrowsing" | translate }}</h5>
                            <span>
                              <label class="switch">
                                <input type="checkbox" id="safeBrowsingEnabled" [checked]="safeBrowsingEnabled"
                                  (change)="onSafeBrowserToggle($event)" />
                                <span class="slider round"></span>
                              </label>

                            </span>
                          </div>
                          <div class="d-flex justify-content-between">
                            <div class="parental-control-string-l mx-4 mb-3 ms-5" style="color: #8C8C8C;"
                              *ngIf="userName != null">
                              {{'LASTUPDATED.LASTUPDATE' | translate }} {{ smartParentingLastSyncTime }}
                            </div>
                          </div>
                        </div>

                        <p class="parental-control-string-l mt-1">
                          {{ "SETTINGSMAIN.PREVENTHARMFULSITES" | translate }}
                        </p>
                        <hr style="margin-left: -32px" />
                      </div>


                      <div class="d-flex justify-content-between">
                        <div class="d-flex align-items-center gap-3">
                          <h5 class="fw-bold">
                            {{ "SETTINGS.PARENTALCONTROL" | translate }}
                          </h5>
                          <span>
                            <label class="switch">
                              <input type="checkbox" [(ngModel)]="isSmartParentingOn"
                                [ngModelOptions]="{ standalone: true }"
                                (change)="onChangeSmartParentingToggle($event)" />
                              <span class="slider round"></span>
                            </label>
                          </span>
                        </div>
                      </div>

                      <div>
                        <p class="mb-0 parental-control-string-l">
                          {{ "SETTINGS.SMARTPARANTINGTEXT" | translate }}
                        </p>
                      </div>
                      <hr style="margin-left: -32px;" />

                      <!-- Apply conditional styling to disable content when isSmartParentingOn is false -->
                      <div [ngClass]="{ 'disabled-yt-section': !isSmartParentingOn }"
                        [ngStyle]="{ 'color': isSmartParentingOn ? 'unset' : '#bcbcbc', 'pointer-events': isSmartParentingOn ? 'auto' : 'none' }">
                        <div style="margin-left: -13px;">
                          <ul class="nav nav-tabs bg-white reportTabs manage-navtabs">
                            <li class="nav-item">
                              <a href="#tabs-activeuser" class="nav-link" (click)="openTabs('SAFEBROWSING')"
                                [class.active]="isSafeBrowsingTab" id="tabs-activeuser-tab" data-bs-toggle="pill"
                                data-bs-target="#tabs-activeuser" role="tab" aria-controls="tabs-activeuser"
                                aria-selected="true" [attr.disabled]="!isSmartParentingOn ? 'disabled' : null">
                                {{ "SETTINGSMAIN.INTERNETBROWSING" | translate }}
                              </a>
                            </li>
                            <li class="nav-item">
                              <a href="#tabs-signuppending" class="nav-link" (click)="openTabs('APPLOCK')"
                                [class.active]="isAppLockTab" id="tabs-signuppending-tab" data-bs-toggle="pill"
                                data-bs-target="#tabs-signuppending" role="tab" aria-controls="tabs-signuppending"
                                aria-selected="false" [attr.disabled]="!isSmartParentingOn ? 'disabled' : null">
                                {{ "SETTINGS.appLockTxt" | translate }}
                              </a>
                            </li>
                          </ul>
                        </div>
                        <div *ngIf="isAppLockTab" class="mt-3"
                          [ngClass]="{ 'disabled-yt-section': !isSmartParentingOn }">
                          <span class="font-weight-600 font-14">{{ "SETTINGS.APPLOCKBLOCKNEWDEVICETEXT" | translate
                            }}</span>
                          <div class="d-flex mt-3">
                            <div>
                              <label class="terms-checkbox">
                                <input type="checkbox" id="playstore_checkbox" [checked]="preventAppInstallaion"
                                  (change)="onBlockPlayStoreClick($event)" class="align-middle"
                                  [disabled]="!isSmartParentingOn" />
                                <span class="checkmark"></span>
                              </label>
                            </div>
                            <div class="font-14">
                              {{ "SETTINGS.PLAYSTORECHECBOXAPPLOCKTXT" | translate }}
                            </div>
                          </div>
                          <div class="d-flex mt-1">
                            <span>
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                class="bi bi-info-circle" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                <path
                                  d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                              </svg>
                              <span class="ms-1 font-14">
                                {{ "SETTINGS.PLAYSTORECHECBOXINFOTXT" | translate }}
                              </span>
                            </span>
                          </div>
                          <hr style="margin-left: -10px" />
                        </div>

                        <!-- Application Block category -->
                        <div class="accordion mt-3 faq-accordion" style="margin-right: 20px;" *ngIf="isAppLockTab"
                          [ngClass]="{ 'disabled-yt-section': !isSmartParentingOn }">
                          <div class="accordion-item bg-white mb-4">
                            <div class="accordion-header mb-0" id="headingOne300">
                              <button [ngClass]="
                                          false
                                            ? 'accordion-button shadow-none relative p-3 bg-white border-0'
                                            : 'accordion-button shadow-none collapsed relative p-3 bg-white border-0'
                                        " type="button" data-bs-toggle="collapse" data-bs-target="#collapse_300"
                                aria-expanded="false" aria-controls="collapseOne300"
                                [attr.disabled]="!isSmartParentingOn ? 'disabled' : null">
                                <div class="col-11">
                                  <div class="row">
                                    <span class="me-4">{{'SETTINGS.BLOCKEDAPPCAT' | translate}}</span>
                                  </div>
                                  <div class="row mt-1 p-0 font-weight-400 font-14">
                                    <span class="p-0">{{ "SETTINGS.BLOCKEDAPPCATSUBTITLE" | translate}}</span>
                                  </div>
                                </div>
                              </button>
                            </div>
                            <div id="collapse_300" [ngClass]="
                                        false
                                          ? 'accordion-collapse collapse show'
                                          : 'accordion-collapse collapse'
                                      " aria-labelledby="headingOne300" data-bs-parent="#accordionExamplenew">
                              <div class="accordion-body">
                                <div class="d-flex">
                                  <div>
                                    <label class="terms-checkbox">
                                      <input type="checkbox" id="option_checkbox" [checked]="allAppChecked"
                                        (change)="onBlockApplicationClick($event, restrictAppCategoryArray, 'multiple')"
                                        class="align-middle" [disabled]="!isSmartParentingOn" />
                                      <span class="checkmark"></span>
                                    </label>
                                  </div>
                                  <div>
                                    {{ "SETTINGSMAIN.SELECTALL" | translate }}
                                  </div>
                                </div>
                                <hr />
                                <form [formGroup]="parentalControlForm">
                                  <div class="row" formArrayName="restAppCategoryList">
                                    <div class="col-sm-4 mb-3"
                                      *ngFor="let item of restrictAppCategoryArray.controls; let i = index"
                                      [formGroupName]="i">
                                      <div class="d-flex">
                                        <div>
                                          <label class="terms-checkbox">
                                            <input type="checkbox" class="form-control p-0" formControlName="isChecked"
                                              (change)="onBlockApplicationClick($event, item, 'single')"
                                              [disabled]="!isSmartParentingOn" />
                                            <span class="checkmark"></span>
                                          </label>
                                        </div>
                                        <div>{{ 'CATEGORYDATA.'+item.value.key | translate }}</div>
                                      </div>
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>

                          <!-- Block Particular Application -->
                          <div class="accordion-item bg-white mb-4">
                            <h2 class="accordion-header mb-0" id="headingThree">
                              <button
                                class="accordion-button shadow-none collapsed relative p-3 text-base text-start bg-white border-0"
                                type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded
                                Ang-expanded="false" aria-controls="collapseThree"
                                [attr.disabled]="!isSmartParentingOn ? 'disabled' : null">
                                <div class="col-11">
                                  <div class="row">
                                    <span>{{ "SETTINGSMAIN.ALLOWEDAPPS" | translate }}</span>
                                  </div>
                                  <div class="row mt-1 p-0 font-weight-400 font-14">
                                    <span class="p-0">{{ "SETTINGS.BLOCKEDAPPSSUBTITLETXT" | translate }}</span>
                                  </div>
                                </div>
                              </button>
                            </h2>
                            <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree">
                              <div class="accordion-body p-4">
                                <div class="bottom-border">
                                  <div class="mb-3">
                                    <span>
                                      <div class="dropdown dashboard-tooltip cursor-pointer">
                                        <div class="dropdown-content">
                                          <div class="d-flex flex-column" i18n-title>
                                            <div> {{ "SETTINGS.MESSEGES.TOOLTIPMESSEGE" | translate }} </div>
                                          </div>
                                        </div>
                                      </div>
                                    </span>
                                    <span>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                        class="bi bi-info-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                        <path
                                          d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                                      </svg>
                                      <span class="ms-1">
                                        {{ "SETTINGS.ALLOWEDAPPNOTE" | translate }}
                                      </span>
                                    </span>
                                  </div>
                                </div>
                                <div>
                                  <div class="mt-2">
                                    <span class="font-weight-600"> {{ "SETTINGS.APPSALLOWED" | translate }} {{ "(" +
                                      (allowedAppList != null ? allowedAppList?.length : 0) + ")"}}</span>
                                  </div>
                                  <div class="row mt-3">
                                    <div class="col-sm-4 mb-3" *ngFor="let item of allowedAppList">
                                      <div class="d-flex">
                                        <div>{{ item }}</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div *ngIf="isSafeBrowsingTab" [ngClass]="{ 'disabled-yt-section': !isSmartParentingOn }">

                          <!-- Set browser Control Category Settings -->

                          <div class="mt-4">
                            <h6 class="fw-bold mb-3">
                              {{ "SETTINGSMAIN.SETBROWSERPARENTALCONTROL" | translate }}
                            </h6>

                            <div class="form-div" [formGroup]="parentalControlForm">
                              <!-- Use Custom Browser = false (standard browsers allowed) -->
                              <div class="form-check radio-item">
                                <input class="form-check-input cursor-pointer" type="radio"
                                  formControlName="useCustomBrowser" [value]="true" id="standardBrowser"
                                  (change)="browserList('Standard')" />
                                <label class="form-check-label fw-normal" for="standardBrowser">
                                  <span class="fw-bold" i18n-title>{{
                                    "SETTINGSMAIN.STANDARDBROWERALLOWED" | translate
                                    }}</span>
                                </label>
                              </div>

                              <div class="ml-30 mb-2 mt-2 parental-control-string" i18n-title>
                                {{ "SETTINGSMAIN.SUPPORTEDBROWSERS" | translate }}
                              </div>

                              <div class="mb-3">
                                <div style="margin-left: 27px;" class="d-flex align-items-start">
                                  <img src="assets/images/Info.svg" alt="" class="me-2" />
                                  <p class="parental-control-string mb-0" i18n-title>
                                    {{ "SETTINGSMAIN.STANDARDBROWSERINFO" | translate }}
                                  </p>
                                </div>
                              </div>


                              <!-- Use Custom Browser = true -->
                              <div class="form-check radio-item">
                                <input class="form-check-input cursor-pointer" type="radio"
                                  formControlName="useCustomBrowser" [value]="false" id="useqhbrowser"
                                  (change)="browserList('custom')" />
                                <label class="form-check-label fw-normal" for="useqhbrowser">
                                  <span class="fw-bold" i18n-title>{{
                                    "SETTINGSMAIN.USEQUICKHEALBROWSER" | translate
                                    }}</span>
                                </label>
                              </div>

                              <div class="mb-4 mt-2 parental-control-string" style="margin-left: 35px;" i18n-title>
                                {{ "SETTINGSMAIN.DESIGNEDFORMAXIMUMPROTECTION" | translate }}
                              </div>
                            </div>

                            <hr style="margin-left: 0px;margin-right: 30px;" />
                          </div>


                          <div class="accordion mt-3 faq-accordion" style="margin-right: 20px;">

                            <!-- Restrict Category Settings -->

                            <div class="accordion-item bg-white mb-3">
                              <h2 class="accordion-header mb-0" id="headingOne">
                                <button
                                  class="accordion-button shadow-none collapsed relative p-3 text-base text-start bg-white border-0"
                                  type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne"
                                  aria-expanded="false" aria-controls="collapseOne"
                                  [attr.disabled]="!isSmartParentingOn ? 'disabled' : null" i18n-title>
                                  <div class="col-11">
                                    <div class="row">
                                      <span class="me-4">{{'SETTINGSMAIN.RESTRICTCATEGORY' | translate}}</span>
                                    </div>
                                    <div class="row mt-1 p-0 font-weight-400 font-14">
                                      <span class="p-0 parental-control-string">{{ "SETTINGS.BLOCKCATSUBTITLE" |
                                        translate}}</span>
                                    </div>
                                  </div>
                                </button>

                              </h2>
                              <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne">
                                <div class="accordion-body p-4">
                                  <div class="d-flex">
                                    <div>
                                      <label class="terms-checkbox">
                                        <input type="checkbox" class="cursor-pointer " id="option_checkbox"
                                          [checked]="allChecked" (change)="
                                  onDeviceClickrestrict(
                                    $event,
                                    restrictCategoryList,
                                    'multiple'
                                  )
                                " class="align-middle" />
                                        <span class="checkmark"></span>
                                      </label>
                                    </div>
                                    <div i18n-title>
                                      {{ "SETTINGSMAIN.SELECTALL" | translate }}
                                    </div>
                                  </div>
                                  <hr />
                                  <form [formGroup]="parentalControlForm">
                                    <div class="row" formArrayName="restrictCategoryList">
                                      <div class="col-sm-4 mb-3"
                                        *ngFor="let item of getRestrictCategoryList.controls; let i = index"
                                        [formGroupName]="i">
                                        <div class="d-flex">
                                          <div>
                                            <label class="terms-checkbox">
                                              <input type="checkbox" class="form-control p-0"
                                                formControlName="isChecked"
                                                (change)="onDeviceClickrestrict($event,item, 'single')"
                                                [disabled]="!isSmartParentingOn" />
                                              <span class="checkmark"></span>
                                            </label>
                                          </div>
                                          <div>{{ 'CATEGORYDATA.'+item.value.key | translate }}</div>
                                        </div>
                                      </div>
                                    </div>
                                  </form>
                                </div>
                              </div>
                            </div>

                            <!-- Block Particular Web Category Settings -->

                            <div class="accordion-item bg-white mb-3">
                              <h2 class="accordion-header mb-0" id="headingThree">
                                <button
                                  class="accordion-button shadow-none collapsed relative p-3 text-base text-start bg-white border-0"
                                  type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree"
                                  aria-expanded="false" aria-controls="collapseThree" i18n-title>
                                  <div class="col-11">
                                    <div class="row">
                                      <span class="me-4">{{'SETTINGSMAIN.BLOCKPARTICULARWEB' | translate}}</span>
                                    </div>
                                    <div class="row mt-1 p-0 font-weight-400 font-14">
                                      <span class="p-0 parental-control-string">{{ "SETTINGS.BLOCKWEBSITESUBTITLE" |
                                        translate}}</span>
                                    </div>
                                  </div>
                                </button>
                              </h2>
                              <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                                data-bs-parent="#accordionExample">
                                <div class="accordion-body p-4">
                                  <div class="form-div">
                                    <label for="website url">{{
                                      "SETTINGSMAIN.ENTERWEBURL" | translate
                                      }}</label>

                                    <div class="d-flex mb-2 gap-3 justify-content-end align-items-center mt-2">
                                      <input type="url" placeholder="{{'SETTINGSMAIN.EXAMPLE.COM' | translate}}"
                                        class="form-control q-form-control" name="blockSite" [(ngModel)]="blockSite"
                                        [ngModelOptions]="{ standalone: true }" #myblockWebsite />

                                      <div i18n-title>
                                        <button type="button" class="q-form-white-submit" style="width: max-content;"
                                          (click)="blockParticluarWebsiteSiteUrl()" i18n-title>
                                          {{ "ADDDEVICE.ADD" | translate }}
                                        </button>
                                      </div>
                                    </div>
                                    <div>
                                      <p class="errMessage">{{ recordExist }}</p>
                                    </div>

                                    <div class="row" *ngIf="blockParticularWebList?.length != 0">
                                      <p class="mt-4 mb-2 blocked-website-string" i18n-title>
                                        {{
                                        "SETTINGSMAIN.BLOCKEDWEBSITELIST"
                                        | translate
                                        }} ({{ blockParticularWebList?.length || 0 }})
                                      </p>

                                      <div *ngFor="let item of blockParticularWebList; let i = index"
                                        class="mb-2 pb-2 border-bottom">
                                        <div class="d-flex justify-content-between align-items-center">
                                          <p class="mb-2 mt-2 parental-control-string truncate-text" [title]="item">
                                            {{ item }}
                                          </p>
                                          <img src="./assets/images/DeleteIcon.svg"
                                            [alt]="'MANAGEDEVICE.DELETE' | translate"
                                            class="cursor-pointer ms-2 delete-icon" (click)="deleteSelectedIndex(item)"
                                            [title]="'MANAGEDEVICE.DELETE' | translate"
                                            style="height: 22px; width: 22px;" />
                                        </div>
                                      </div>
                                    </div>

                                    <div *ngIf="blockParticularWebList?.length == 0">
                                      <p class="fw-bold mb-0" i18n-title>
                                        {{
                                        "SETTINGSMAIN.BLOCKPARTICULARWEBSITENOTFOUND"
                                        | translate
                                        }}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <!-- Excluded Website Category Settings -->

                            <div class="accordion-item bg-white mb-3">
                              <h2 class="accordion-header mb-0" id="headingTwo">
                                <button
                                  class="accordion-button shadow-none collapsed relative p-3 text-base text-start bg-white border-0"
                                  type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo"
                                  aria-expanded="false" aria-controls="collapseTwo" i18n-title>
                                  <div class="col-11">
                                    <div class="row">
                                      <span class="me-4">{{'SETTINGSMAIN.EXCLUDEDWEBSITE' | translate}}</span>
                                    </div>
                                    <div class="row mt-1 p-0 font-weight-400 font-14">
                                      <span class="p-0 parental-control-string">{{ "SETTINGS.ADDTRUSTEDWEBSITES" |
                                        translate}}</span>
                                    </div>
                                  </div>
                                </button>
                              </h2>
                              <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo">
                                <div class="accordion-body p-4">
                                  <div class="form-div">
                                    <label for="website url">{{
                                      "SETTINGSMAIN.ENTERWEBURL" | translate
                                      }}</label>
                                    <div class="d-flex mb-2 gap-3 justify-content-end align-items-center mt-2">
                                      <input type="url" placeholder="{{'SETTINGSMAIN.EXAMPLE.COM' | translate}}"
                                        class="form-control q-form-control" name="ExcludeWebsite"
                                        [ngModelOptions]="{ standalone: true }" [(ngModel)]="ExcludeWebsite" />
                                      <div i18n-title>
                                        <button type="button" class="q-form-white-submit" style="width: max-content;"
                                          (click)="addExcludeWebSiteUrl()">
                                          {{ "ADDDEVICE.ADD" | translate }}
                                        </button>
                                      </div>
                                    </div>
                                    <div>
                                      <p class="errMessage">{{ recordExistForExcludedWebsite }}</p>
                                    </div>
                                    <div class="row" *ngIf="websiteList?.length != 0">
                                      <p class="mt-4 mb-2 blocked-website-string" i18n-title>
                                        {{
                                        "SETTINGSMAIN.EXCLUDEDWEBSITELIST"
                                        | translate
                                        }} ({{ websiteList.length || 0 }})
                                      </p>

                                      <div *ngFor="let item of websiteList; let i = index"
                                        class="mb-2 pb-2 border-bottom">
                                        <div class="d-flex justify-content-between align-items-center">
                                          <p class="mb-2 mt-2 parental-control-string truncate-text" [title]="item">
                                            {{ item }}
                                          </p>
                                          <img src="./assets/images/DeleteIcon.svg"
                                            [alt]="'MANAGEDEVICE.DELETE' | translate"
                                            class="cursor-pointer ms-2 delete-icon"
                                            (click)="deleteSelectedExcludedIndex(item)"
                                            [title]="'MANAGEDEVICE.DELETE' | translate"
                                            style="height: 22px; width: 22px;" />
                                        </div>
                                      </div>
                                    </div>
                                    <div *ngIf="websiteList?.length == 0">
                                      <p class="fw-bold mb-0" i18n-title>
                                        {{"SETTINGSMAIN.EXCLUDEDWEBSITENOTFOUND" | translate }}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>



                        </div>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="selctedTabType == 'screenTime'" class="ml-2rem">
                    <div class="mb-4 mt-4">
                      <div class="d-flex justify-content-between">
                        <div class="d-flex align-items-center gap-3">
                          <h5 class="fw-bold">
                            {{ "SETTINGS.SCREENTIME" | translate }}
                          </h5>
                          <span>
                            <label class="switch">
                              <input type="checkbox" [(ngModel)]="isScreenTimeOn"
                                [ngModelOptions]="{ standalone: true }" (change)="onChangeScreenToggle($event)" />
                              <span class="slider round"></span>
                            </label>
                          </span>
                        </div>
                        <div class="d-flex justify-content-between">
                          <div class="parental-control-string-l mx-4 mb-3 ms-5" style="color: #8C8C8C;"
                            *ngIf="userName != null">
                            {{'LASTUPDATED.LASTUPDATE' | translate }} {{ screenTimeLastSyncTime }}
                          </div>
                        </div>
                      </div>

                      <div>
                        <p class="mb-0 settings-security-feature">
                          {{ "SETTINGS.SCREENTIMETEXT" | translate }}
                        </p>
                      </div>
                      <hr style="margin-left: -32px" />
                      <form class="q-addDeviceModal mb-4" [formGroup]="screentimeForm" [ngStyle]="{
                          color: isScreenTimeOn ? 'unset' : '#bcbcbc'
                        }">
                        <div class="d-flex flex-column gap-3">
                          <div class="d-flex flex-column">
                            <span class="font-weight-600">{{'MANAGEDEVICE.SETDAILYSCREENTIMESTR' | translate }}</span>
                            <span style="font-size: 14px">{{'MANAGEDEVICE.SETTIMEGOAL' | translate }}</span>
                          </div>
                          <div class="d-flex flex-column gap-2" [ngClass]="{ 'disabled-yt-section': !isScreenTimeOn }">
                            <div class="d-flex gap-4">
                              <div class="d-flex flex-column">
                                <label for="screenTimeHours" class="font-weight-700">{{'MANAGEDEVICE.HOURS' | translate
                                  }}</label>
                                <select name="screenTimeHours" id="screenTimeHours"
                                  formControlName="dailyScreenTimeHours" [disabled]="!isScreenTimeOn">
                                  <option *ngFor="let hour of hours" [value]="hour">{{ hour }}</option>
                                </select>
                              </div>
                              <div class="d-flex flex-column">
                                <label for="screenTimeMinutes" class="font-weight-700">{{'MANAGEDEVICE.MINUTES' |
                                  translate }}</label>
                                <select name="screenTimeMinutes" id="screenTimeMinutes"
                                  formControlName="dailyScreenTimeMinutes" [disabled]="!isScreenTimeOn">
                                  <option *ngFor="let minute of minutes" [value]="minute">
                                    {{ minute | number: '2.0-0' }}
                                  </option>
                                </select>
                              </div>
                            </div>
                            <div id="screenTimeWarning" style="font-size: 14px; color: red;"
                              *ngIf="showScreenTimeWarning">
                              <span class="font-weight-700">{{'MANAGEDEVICE.WARNINGTEXT' | translate
                                }}</span>{{'MANAGEDEVICE.SCREENTIMEWARNING' | translate }}
                            </div>
                          </div>
                          <div class="d-flex gap-1">
                            <div>
                              <label class="terms-checkbox">
                                <input type="checkbox" class="align-middle" [disabled]="!isScreenTimeOn"
                                  [ngClass]="{ 'disabled-yt-section': !isScreenTimeOn }" [(ngModel)]="isLockOnTimeOut"
                                  [ngModelOptions]="{ standalone: true }" (change)="onChangeLockOnTimeOut($event)" />
                                <span class="checkmark" [ngClass]="{ 'disabled-yt-section': !isScreenTimeOn }"></span>
                              </label>
                            </div>
                            <div style="font-size: 15px">
                              {{'MANAGEDEVICE.SCREENTIMECHECKBOXTEXT' | translate
                              }}
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>

                  <div *ngIf="selctedTabType == 'YTSupervision'" class="ml-2rem">
                    <div class="col-md-12">
                      <ng-container *ngIf="showPremium">
                        <div class="mt-4 bg-white p-3" style="border-radius: 12px;">
                          <div class="col-sm-12 relative">
                            <div class="pt-3">
                              <div class="mb-3 text-center">
                                <div class="mt-2">
                                  <span><img src="./assets/images/upgradeToPremium.svg" alt=""></span>
                                </div>
                                <div class="mt-2 pt-1 pb-1">
                                  <span *ngIf="status === 'Free version'  || licenseValidity === 'Free version'"
                                    class="empty-report-text">{{
                                    "DASHBOARD.PREMIUMFEATUREUPGARDE" | translate }}</span>
                                  <span *ngIf="status === 'LICENSE_EXPIRED'  || licenseValidity === 'LICENSE_EXPIRED'"
                                    class="empty-report-text"> {{
                                    "DASHBOARD.PREMIUMFEATURERENEW" | translate }} </span>
                                </div>
                                <div class="mt-2 pt-1">
                                  <button *ngIf="status === 'Free version'  || licenseValidity === 'Free version'"
                                    (click)="navigateToRenew()"
                                    class="submit-btn bg-orgclr py-2 px-4 add-device shadow-none">
                                    {{ "LICENSESUMMARY.UPGRADE" | translate }}
                                  </button>
                                  <button *ngIf="status === 'LICENSE_EXPIRED'  || licenseValidity === 'LICENSE_EXPIRED'"
                                    (click)="navigateToRenew()"
                                    class="submit-btn bg-orgclr py-2 px-4 add-device shadow-none">
                                    {{ "LICENSESUMMARY.RENEW" | translate }}
                                  </button>
                                </div>

                                <div class="mt-2 pt-1 d-flex justify-content-center">
                                  <div class="pt-4"
                                    *ngIf="status === 'Free version' ||  licenseValidity === 'Free version'">
                                    <div class="p-4 expiry-text-background-color border premium-box text-start">
                                      <div>
                                        <span class="font-weight-600">
                                          {{ "SETTINGS.YTSUPERVISIONPRIMESTRING" | translate}}
                                        </span>
                                      </div>
                                      <div class="mt-1">
                                        <span>
                                          {{ "SETTINGS.YTSUPERVISIONPRIMESUBSTRING" | translate}}
                                        </span>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="pt-4"
                                    *ngIf="status === 'LICENSE_EXPIRED' ||  licenseValidity === 'LICENSE_EXPIRED'">
                                    <div class="p-4 expiry-text-background-color border premium-box text-start">
                                      <div>
                                        <span class="font-weight-600">
                                          {{ "SETTINGS.YTSUPERVISIONPRIMESTRING" | translate}}
                                        </span>
                                      </div>
                                      <div class="mt-1">
                                        <span>
                                          {{ "SETTINGS.YTSUPERVISIONPRIMERENEWSUBSTRING" | translate}}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>


                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                    <div class="mb-4 mt-4" *ngIf="!showPremium">
                      <div class="d-flex justify-content-between">
                        <div class="d-flex align-items-center gap-3">
                          <h5 class="fw-bold">
                            {{ "SETTINGS.YOUTUBESUPERVISION" | translate }}
                          </h5>
                          <span>
                            <label class="switch">
                              <input type="checkbox" [(ngModel)]="isYoutubeSuperVisionOn"
                                [ngModelOptions]="{ standalone: true }"
                                (change)="onChangeYoutubeSuperVisionToggle($event)" />
                              <span class="slider round"></span>
                            </label>
                          </span>
                        </div>
                        <div class="d-flex justify-content-between">
                          <div class="parental-control-string-l mx-4 mb-3 ms-5" style="color: #8C8C8C;"
                            *ngIf="userName != null">
                            {{'LASTUPDATED.LASTUPDATE' | translate }} {{ ytSuperVisionLastSyncTime }}
                          </div>
                        </div>
                      </div>
                      <div>
                        <p class="mb-0 settings-security-feature">
                          {{ "SETTINGS.YOUTUBESUPERVISIONDESCRIPTION" | translate }}
                        </p>
                      </div>

                      <hr style="margin-left: -32px" />

                      <div class="d-flex justify-content-between"
                        [ngClass]="{ 'disabled-yt-section': !isYoutubeSuperVisionOn }">
                        <div class="d-flex align-items-center gap-4">
                          <h5 style="font-weight: 600; font-size: 16px;">
                            {{ "SETTINGS.BLOCKYTSHORTSTXT" | translate }}
                          </h5>
                          <span>
                            <label class="switch">
                              <input type="checkbox" [(ngModel)]="isBlockedYTShorts"
                                [ngModelOptions]="{ standalone: true }"
                                (change)="onChangeBlockYTShortsToggle($event)" />
                              <span class="slider round"></span>
                            </label>
                          </span>
                        </div>
                      </div>
                      <div [ngClass]="{ 'disabled-yt-section': !isYoutubeSuperVisionOn }">
                        <p class="mb-0 settings-security-feature">
                          {{ "SETTINGS.BLOCKYTSHORTSDESCRIPTION" | translate }}
                        </p>
                      </div>
                      <hr style="margin-left: 0px;margin-right: 20px;" />
                    </div>
                    <div [ngClass]="{ 'disabled-yt-section': !isYoutubeSuperVisionOn }" *ngIf="!showPremium">
                      <h5 style="font-weight: 600; font-size: 16px;">
                        {{"SETTINGS.RESTRICTED" | translate}}
                      </h5>
                    </div>

                    <div class="accordion mt-3 faq-accordion" *ngIf="!showPremium" style="margin-right: 20px;"
                      [ngClass]="{ 'disabled-yt-section': !isYoutubeSuperVisionOn }">

                      <!-- block channels -->
                      <div class="accordion-item bg-white mb-4">
                        <div class="accordion-header mb-0" id="ytBlockChannelAcc">
                          <button [ngClass]="
                                          false
                                            ? 'accordion-button shadow-none relative p-3 bg-white border-0'
                                            : 'accordion-button shadow-none collapsed relative p-3 bg-white border-0'
                                        " type="button" data-bs-toggle="collapse"
                            data-bs-target="#ytBlockChannelAccTarget" aria-expanded="false"
                            aria-controls="ytBlockChannelAcc"
                            [attr.disabled]="!isYoutubeSuperVisionOn ? 'disabled' : null">
                            <div class="col-11">
                              <div class="row font-weight-700-font-size-16">
                                <span class="me-4">{{'SETTINGS.YTBLOCKCHANNELACCORDIANHEADER' |
                                  translate}}</span>
                              </div>
                              <div class="row mt-1 p-0 font-weight-400 font-14">
                                <span class="p-0">{{ "SETTINGS.YTBLOCKCHANNELACCORDIANDESC" | translate}}</span>
                              </div>
                            </div>
                          </button>
                        </div>
                        <div id="ytBlockChannelAccTarget" [ngClass]="
                                        false
                                          ? 'accordion-collapse collapse show'
                                          : 'accordion-collapse collapse'
                                      " aria-labelledby="headingOne300" data-bs-parent="#accordionExamplenew">

                          <div class="accordion-body">
                            <label class="mb-2 font-weight-600">{{
                              "SETTINGS.YTENTERCHANNELNAME" | translate
                              }}</label>
                            <div class="d-flex mb-2 gap-3">
                              <input type="text" class="form-control"
                                [ngStyle]="{ width: selectedLanguage === 'ja' ? '81%' : '100%' }"
                                placeholder="{{'SETTINGS.YTENTERCHANNELNAME' | translate}}"
                                [(ngModel)]="ytBlockedChannelInput" [ngModelOptions]="{ standalone: true }">
                              <button (click)="addYtBlockedChannel()" class="q-form-white-submit">{{'ADDDEVICE.ADD' |
                                translate}}</button>
                            </div>
                            <div>
                              <p class="errMessage">{{ ytBlockedChannelRecordExist }}</p>
                            </div>
                            <div>
                              <div class="mt-2">
                                <span class="font-weight-600"> {{ "SETTINGS.YTBLOCKEDCHANNELLIST" | translate }} {{
                                  "(" +
                                  (ytBlockedChannels != null ? ytBlockedChannels?.length : 0) + ")"}}</span>
                              </div>
                              <div class="d-flex flex-wrap gap-3 mt-3">
                                <div *ngFor="let item of ytBlockedChannels; let i = index">
                                  <div class="yt-channel-tag px-3 py-2 d-flex align-items-center">
                                    <span>{{ item }}</span>
                                    <img src="./assets/images/ytClear.svg" [alt]="'MANAGEDEVICE.DELETE' | translate"
                                      class="ms-3 cursor-pointer" (click)="removeYtBlockedChannel(i)"
                                      [title]="'MANAGEDEVICE.DELETE' | translate" style="height: 16px;" />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <ng-template #noChannels>
                              <div class="text-muted">No blocked channels.</div>
                            </ng-template>
                          </div>
                        </div>
                      </div>

                      <!-- Block Particular Video links -->
                      <div class="accordion-item bg-white mb-4">
                        <h2 class="accordion-header mb-0" id="ytBlockVideoAcc">
                          <button
                            class="accordion-button shadow-none collapsed relative p-3 text-base text-start bg-white border-0"
                            type="button" data-bs-toggle="collapse" data-bs-target="#ytBlockVideoAccTarget"
                            aria-expanded Ang-expanded="false" aria-controls="ytBlockVideoAccTarget"
                            [attr.disabled]="!isYoutubeSuperVisionOn ? 'disabled' : null">
                            <div class="col-11">
                              <div class="row font-weight-700-font-size-16">
                                <span>{{ "SETTINGS.YTBLOCKVIDEOSACCORDIANHEADER" | translate }}</span>
                              </div>
                              <div class="row mt-1 p-0 font-weight-400 font-14">
                                <span class="p-0">{{ "SETTINGS.YTBLOCKVIDEOSACCORDIANDESC" | translate }}</span>
                              </div>
                            </div>
                          </button>
                        </h2>
                        <div id="ytBlockVideoAccTarget" class="accordion-collapse collapse"
                          aria-labelledby="ytBlockVideoAcc">
                          <div class="accordion-body p-4">
                            <label class="mb-2 font-weight-600">{{
                              "SETTINGS.YTBLOCKVIDEOSINPUTLABLE" | translate
                              }}</label>
                            <div class="d-flex mb-2 gap-3">
                              <input type="text" class="form-control"
                                [ngStyle]="{ width: selectedLanguage === 'ja' ? '81%' : '100%' }"
                                placeholder="{{'SETTINGS.YTBLOCKVIDEOSINPUTPLACEHOLDER' | translate}}"
                                [(ngModel)]="ytBlockedVideoInput" [ngModelOptions]="{ standalone: true }">
                              <button (click)="addYtBlockedVideo()" class="q-form-white-submit">{{'ADDDEVICE.ADD' |
                                translate}}</button>
                            </div>
                            <div>
                              <p class="errMessage">{{ ytBlockedVideoRecordExist }}</p>
                            </div>
                            <div class="row" *ngIf="ytBlockedVideos?.length != 0">
                              <p class="mt-4 mb-2 blocked-website-string" i18n-title>
                                {{
                                "SETTINGSMAIN.BLOCKEDWEBSITELIST"
                                | translate
                                }} ({{ ytBlockedVideos?.length || 0 }})
                              </p>

                              <div *ngFor="let item of ytBlockedVideos; let i = index" class="mb-2 pb-2 border-bottom">
                                <div class="d-flex justify-content-between align-items-center">
                                  <p class="mb-2 mt-2 parental-control-string truncate-text" [title]="item">
                                    {{ item }}
                                  </p>
                                  <img src="./assets/images/DeleteIcon.svg" [alt]="'MANAGEDEVICE.DELETE' | translate"
                                    class="cursor-pointer ms-2 delete-icon" (click)="removeYtBlockedVideo(i)"
                                    [title]="'MANAGEDEVICE.DELETE' | translate" style="height: 22px; width: 22px;" />
                                </div>
                              </div>
                              <div>
                                <p class="errMessage">{{ recordExist }}</p>
                              </div>
                            </div>
                            <div *ngIf="ytBlockedVideos?.length == 0">
                              <p class="fw-bold mb-0" i18n-title>
                                {{
                                "SETTINGSMAIN.BLOCKPARTICULARWEBSITENOTFOUND"
                                | translate
                                }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Block by categories -->
                      <div class="accordion-item bg-white mb-4">
                        <h2 class="accordion-header mb-0" id="ytBlockCategoryAcc">
                          <button
                            class="accordion-button shadow-none collapsed relative p-3 text-base text-start bg-white border-0"
                            type="button" data-bs-toggle="collapse" data-bs-target="#ytBlockCategoryAccTarget"
                            aria-expanded Ang-expanded="false" aria-controls="ytBlockCategoryAccTarget"
                            [attr.disabled]="!isYoutubeSuperVisionOn ? 'disabled' : null">
                            <div class="col-11">
                              <div class="row font-weight-700-font-size-16">
                                <span>{{ "SETTINGS.YTBLOCKBYCATEGORIESACCORDIANHEADER" | translate }}</span>
                              </div>
                              <div class="row mt-1 p-0 font-weight-400 font-14">
                                <span class="p-0">{{ "SETTINGS.YTBLOCKBYCATEGORIESACCORDIANDESC" | translate }}</span>
                              </div>
                            </div>
                          </button>
                        </h2>
                        <div id="ytBlockCategoryAccTarget" class="accordion-collapse collapse"
                          aria-labelledby="ytBlockCategoryAcc">
                          <div class="accordion-body p-4">
                            <div class="d-flex">
                              <div>
                                <label class="terms-checkbox">
                                  <input type="checkbox" id="option_checkbox" [checked]="ytAllCategoriesChecked"
                                    (change)="toggleAllYtBlockedCategories($event)" class="align-middle"
                                    [disabled]="!isYoutubeSuperVisionOn" />
                                  <span class="checkmark"></span>
                                </label>
                              </div>
                              <div>
                                {{ "SETTINGSMAIN.SELECTALL" | translate }}
                              </div>
                            </div>
                            <hr />
                            <div class="row">
                              <div class="col-sm-4 mb-3" *ngFor="let item of ytBlockedCategories; let i = index">
                                <div class="d-flex">
                                  <div>
                                    <label class="terms-checkbox">
                                      <input type="checkbox" class="form-control p-0" [(ngModel)]="item.isChecked"
                                        (change)="onYtCategoryCheckChange()" [disabled]="!isYoutubeSuperVisionOn" />
                                      <span class="checkmark"></span>
                                    </label>
                                  </div>
                                  <div>{{ 'CATEGORYDATA.'+item.key | translate }}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Block by keywords -->
                      <div class="accordion-item bg-white mb-4">
                        <h2 class="accordion-header mb-0" id="ytBlockKeywordAcc">
                          <button
                            class="accordion-button shadow-none collapsed relative p-3 text-base text-start bg-white border-0"
                            type="button" data-bs-toggle="collapse" data-bs-target="#ytBlockKeywordAccTarget"
                            aria-expanded Ang-expanded="false" aria-controls="ytBlockKeywordAccTarget"
                            [attr.disabled]="!isYoutubeSuperVisionOn ? 'disabled' : null">
                            <div class="col-11">
                              <div class="row font-weight-700-font-size-16">
                                <span>{{ "SETTINGS.YTBLOCKKEYWORDSACCORDIANHEADER" | translate }}</span>
                              </div>
                              <div class="row mt-1 p-0 font-weight-400 font-14">
                                <span class="p-0">{{ "SETTINGS.YTBLOCKKEYWORDSACCORDIANDESC" | translate }}</span>
                              </div>
                            </div>
                          </button>
                        </h2>
                        <div id="ytBlockKeywordAccTarget" class="accordion-collapse collapse"
                          aria-labelledby="ytBlockKeywordAcc">
                          <div class="accordion-body p-4">
                            <label class="mb-2 font-weight-600">{{
                              "SETTINGS.YTBLOCKKEYWORDSINPUTLABEL" | translate
                              }}</label>
                            <div class="d-flex mb-2 gap-3">
                              <input type="text" class="form-control"
                                [ngStyle]="{ width: selectedLanguage === 'ja' ? '81%' : '100%' }"
                                placeholder="{{'SETTINGS.YTBLOCKKEYWORDSINPUTLABEL' | translate}}"
                                [(ngModel)]="ytBlockedKeywordInput" [ngModelOptions]="{ standalone: true }">
                              <button (click)="addYtBlockedKeyword()" class="q-form-white-submit">{{'ADDDEVICE.ADD' |
                                translate}}</button>
                            </div>
                            <div>
                              <p class="errMessage">{{ ytBlockedKeywordRecordExist }}</p>
                            </div>
                            <div>
                              <div class="mt-2">
                                <span class="font-weight-600"> {{ "SETTINGS.YTBLOCKKEYWORDSCOUNT" | translate }} {{
                                  "(" +
                                  (ytBlockedKeywords != null ? ytBlockedKeywords?.length : 0) + ")"}}</span>
                              </div>

                              <div class="d-flex flex-wrap gap-3 mt-3">
                                <div *ngFor="let item of ytBlockedKeywords; let i = index">
                                  <div class="yt-channel-tag px-3 py-2 d-flex align-items-center">
                                    <span>{{ item }}</span>
                                    <img src="./assets/images/ytClear.svg" [alt]="'MANAGEDEVICE.DELETE' | translate"
                                      class="ms-3 cursor-pointer" (click)="removeYtBlockedKeyword(i)"
                                      [title]="'MANAGEDEVICE.DELETE' | translate" style="height: 16px;" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <hr style="margin-left: 0px;margin-right: 0px;" />

                      <div class="mt-4">
                        <h5 style=" font-weight: 600; font-size: 16px;">
                          {{"SETTINGS.ALLOWED" | translate}}
                        </h5>
                      </div>

                      <!-- Allowed channels -->
                      <div class="accordion-item bg-white mb-4">
                        <h2 class="accordion-header mb-0" id="ytAllowedChannelsAcc">
                          <button
                            class="accordion-button shadow-none collapsed relative p-3 text-base text-start bg-white border-0"
                            type="button" data-bs-toggle="collapse" data-bs-target="#ytAllowedChannelsAccTarget"
                            aria-expanded Ang-expanded="false" aria-controls="ytAllowedChannelsAccTarget"
                            [attr.disabled]="!isYoutubeSuperVisionOn ? 'disabled' : null">
                            <div class="col-11">
                              <div class="row font-weight-700-font-size-16">
                                <span>{{ "SETTINGS.YTALLOWEDCHANNELACCORDIANHEADER" | translate }}</span>
                              </div>
                              <div class="row mt-1 p-0 font-weight-400 font-14">
                                <span class="p-0">{{ "SETTINGS.YTALLOWEDCHANNELACCORDIANDESC" | translate }}</span>
                              </div>
                            </div>
                          </button>
                        </h2>
                        <div id="ytAllowedChannelsAccTarget" class="accordion-collapse collapse"
                          aria-labelledby="ytAllowedChannelsAcc">
                          <div class="accordion-body p-4">
                            <label class="mb-2 font-weight-600">{{
                              "SETTINGS.YTENTERCHANNELNAME" | translate
                              }}</label>
                            <div class="d-flex mb-2 gap-3">
                              <input type="text" class="form-control"
                                [ngStyle]="{ width: selectedLanguage === 'ja' ? '81%' : '100%' }"
                                placeholder="{{'SETTINGS.YTENTERCHANNELNAME' | translate}}"
                                [(ngModel)]="ytAllowedChannelInput" [ngModelOptions]="{ standalone: true }">
                              <button (click)="addYtAllowedChannel()" class="q-form-white-submit">{{'ADDDEVICE.ADD' |
                                translate}}</button>
                            </div>
                            <div>
                              <p class="errMessage">{{ ytAllowedChannelRecordExist }}</p>
                            </div>
                            <div>
                              <div class="mt-2">
                                <span class="font-weight-600"> {{ "SETTINGS.YTALLOWEDCHANNELLIST" | translate }} {{
                                  "(" +
                                  (ytAllowedChannels != null ? ytAllowedChannels?.length : 0) + ")"}}</span>
                              </div>
                              <div class="d-flex flex-wrap gap-3 mt-3">
                                <div *ngFor="let item of ytAllowedChannels; let i = index">
                                  <div class="yt-channel-tag px-3 py-2 d-flex align-items-center">
                                    <span>{{ item }}</span>
                                    <img src="./assets/images/ytClear.svg" [alt]="'MANAGEDEVICE.DELETE' | translate"
                                      class="ms-3 cursor-pointer" (click)="removeYtAllowedChannel(i)"
                                      [title]="'MANAGEDEVICE.DELETE' | translate" style="height: 16px;" />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <ng-template #noChannels>
                              <div class="text-muted">No blocked channels.</div>
                            </ng-template>
                          </div>
                        </div>
                      </div>

                      <!-- Allowed Videos -->
                      <div class="accordion-item bg-white mb-4">
                        <h2 class="accordion-header mb-0" id="ytAllowedVideosAcc">
                          <button
                            class="accordion-button shadow-none collapsed relative p-3 text-base text-start bg-white border-0"
                            type="button" data-bs-toggle="collapse" data-bs-target="#ytAllowedVideosAccTarget"
                            aria-expanded Ang-expanded="false" aria-controls="ytAllowedVideosAccTarget"
                            [attr.disabled]="!isYoutubeSuperVisionOn ? 'disabled' : null">
                            <div class="col-11">
                              <div class="row font-weight-700-font-size-16">
                                <span>{{ "SETTINGS.YTALLOWEDVIDEOSACCORDIANHEADER" | translate }}</span>
                              </div>
                              <div class="row mt-1 p-0 font-weight-400 font-14">
                                <span class="p-0">{{ "SETTINGS.YTALLOWEDVIDEOSACCORDIANDESC" | translate }}</span>
                              </div>
                            </div>
                          </button>
                        </h2>
                        <div id="ytAllowedVideosAccTarget" class="accordion-collapse collapse"
                          aria-labelledby="ytAllowedVideosAcc">
                          <div class="accordion-body p-4">
                            <label class="mb-2 font-weight-600">{{
                              "SETTINGS.YTBLOCKVIDEOSINPUTLABLE" | translate
                              }}</label>
                            <div class="d-flex mb-2 gap-3">
                              <input type="text" class="form-control"
                                [ngStyle]="{ width: selectedLanguage === 'ja' ? '81%' : '100%' }"
                                placeholder="{{'SETTINGS.YTBLOCKVIDEOSINPUTPLACEHOLDER' | translate}}"
                                [(ngModel)]="ytAllowedVideoInput" [ngModelOptions]="{ standalone: true }">
                              <button (click)="addYtAllowedVideo()" class="q-form-white-submit"
                                style="width: max-content;">{{'ADDDEVICE.ADD' | translate}}</button>
                            </div>
                            <div>
                              <p class="errMessage">{{ ytAllowedVideoRecordExist }}</p>
                            </div>
                            <div class="row" *ngIf="ytAllowedVideos?.length != 0">
                              <p class="mt-4 mb-2 blocked-website-string" i18n-title>
                                {{
                                "SETTINGS.YTALLOWEDWEBSITELLIST"
                                | translate
                                }} ({{ ytAllowedVideos?.length || 0 }})
                              </p>

                              <div *ngFor="let item of ytAllowedVideos; let i = index" class="mb-2 pb-2 border-bottom">
                                <div class="d-flex justify-content-between align-items-center">
                                  <p class="mb-2 mt-2 parental-control-string truncate-text" [title]="item">
                                    {{ item }}
                                  </p>
                                  <img src="./assets/images/DeleteIcon.svg" [alt]="'MANAGEDEVICE.DELETE' | translate"
                                    class="cursor-pointer ms-2 delete-icon" (click)="removeYtAllowedVideo(i)"
                                    [title]="'MANAGEDEVICE.DELETE' | translate" style="height: 22px; width: 22px;" />
                                </div>
                              </div>

                            </div>
                            <div *ngIf="ytAllowedVideos?.length == 0">
                              <p class="fw-bold mb-0" i18n-title>
                                {{
                                "SETTINGSMAIN.BLOCKPARTICULARWEBSITENOTFOUND"
                                | translate
                                }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                  <div *ngIf="selctedTabType == 'Theft'" class="ml-2rem">
                    <div class="mb-4 mt-4">
                      <div class="d-flex justify-content-between">
                        <div class="d-flex align-items-center gap-3">
                          <h5 class="fw-bold">
                            {{ "MANAGEDEVICE.ANTITHEFTS" | translate }}
                          </h5>
                          <span>
                            <label class="switch">
                              <input type="checkbox" [(ngModel)]="isAntiTheftAndIntrusionSettingOn"
                                [ngModelOptions]="{ standalone: true }"
                                (change)="onChangeAntitheftAndIntrusionSettingsToggle($event)" />
                              <span class="slider round"></span>
                            </label>
                          </span>
                        </div>
                        <div class="d-flex justify-content-between">
                          <div class="parental-control-string-l mx-4 mb-3 ms-5" style="color: #8C8C8C;"
                            *ngIf="userName != null">
                            {{'LASTUPDATED.LASTUPDATE' | translate }} {{ antiTheftLastSyncTime }}
                          </div>
                        </div>
                      </div>
                      <div>
                        <p class="mb-0 settings-security-feature">
                          {{ "SETTINGS.ANTITHEFTANDINTRUSIONDESC" | translate }}
                        </p>
                      </div>

                      <hr style="margin-left: -32px" />

                      <div class="d-flex justify-content-between"
                        [ngClass]="{ 'disabled-yt-section': !isAntiTheftAndIntrusionSettingOn }">
                        <div class="d-flex align-items-center gap-4">
                          <h5 style="font-weight: 600; font-size: 16px;">
                            {{ "SETTINGS.ANTITHEFT" | translate }}
                          </h5>
                          <span>
                            <label class="switch">
                              <input type="checkbox" [(ngModel)]="isAntiTheftSettingsOn"
                                [ngModelOptions]="{ standalone: true }"
                                (change)="onChangeAntitheftSettingsToggle($event)" />
                              <span class="slider round"></span>
                            </label>
                          </span>
                        </div>
                      </div>
                      <div [ngClass]="{ 'disabled-yt-section': !isAntiTheftAndIntrusionSettingOn }">
                        <p class="mb-0 settings-security-feature">
                          {{ "SETTINGS.ANTITHEFTDESC" | translate }}
                        </p>
                      </div>
                      <div class="d-flex gap-1 mt-3"
                        [ngClass]="{ 'disabled-yt-section': !isAntiTheftAndIntrusionSettingOn || !isAntiTheftSettingsOn }">
                        <div>
                          <label class="terms-checkbox">
                            <input type="checkbox" class="align-middle" [(ngModel)]="isBlockOnAirplaneMode"
                              [ngModelOptions]="{ standalone: true }" style="width: 20px; height: 20px;"
                              (change)="onChangeBlockOnAirplaneMode($event)" />
                            <span class="checkmark"></span>
                          </label>
                        </div>
                        <div style="font-size: 15px">
                          {{'SETTINGSMAIN.BLOCKONAIRPLANEMODE' | translate
                          }}
                        </div>
                      </div>
                      <div class="d-flex flex-column gap-2 mt-3"
                        [ngClass]="{ 'disabled-yt-section': !isAntiTheftAndIntrusionSettingOn || !isAntiTheftSettingsOn }">
                        <div class="d-flex gap-4">
                          <div class="d-flex flex-column">
                            <label class="mb-2 font-weight-600-font-size-14">{{
                              "SETTINGS.ANTITHEFTPRIMARYNUMBERLABEL" | translate
                              }}</label>
                            <div class="d-flex mb-2 gap-3">
                              <input type="tel" onlyNumber class="form-control" [maxlength]="10"
                                placeholder="{{'SETTINGS.ANTITHEFTNUMBERPLACEHOLDER' | translate}}"
                                (keyup)="keyPressAlphaNumericWithCharacters($event, 'mobile')"
                                (keypress)="removeSpace($event, 'mobile')" (input)="validateNumbers()"
                                (ngModelChange)="onFocusOutMobile($event, 'mobile')" style="height: 40px;"
                                [(ngModel)]="antiTheftPrimaryNumberInput" [ngModelOptions]="{ standalone: true }">
                            </div>
                            <div>
                              <p class="errMessage" style="margin-top: -5px;">{{ primaryMobileError }}</p>
                            </div>
                          </div>
                          <div class="d-flex flex-column">
                            <label class="mb-2 font-weight-600-font-size-14">{{
                              "SETTINGS.ANTITHEFTALTNUMBERLABEL" | translate
                              }}</label>
                            <div class="d-flex mb-2 gap-3">
                              <input type="tel" onlyNumber class="form-control" [maxlength]="10"
                                placeholder="{{'SETTINGS.ANTITHEFTNUMBERPLACEHOLDER' | translate}}"
                                (keyup)="keyPressAlphaNumericWithCharacters($event, 'mobile')"
                                (keypress)="removeSpace($event, 'mobile')" (input)="validateNumbers()"
                                (ngModelChange)="onFocusOutMobile($event, 'mobile')" style="height: 40px;"
                                [(ngModel)]="antiTheftAlternateNumberInput" [ngModelOptions]="{ standalone: true }">
                            </div>
                            <div>
                              <p class="errMessage" style="margin-top: -5px;">{{ alternateMobileError }}</p>
                            </div>
                          </div>
                        </div>
                        <div>
                          <p class="errMessage" style="margin-top: -20px;" *ngIf="sameNumberError">{{ sameNumberError }}
                          </p>
                        </div>
                      </div>

                      <hr class="mt-0" style="margin-left: 0px;margin-right: 30px;">

                      <div class="d-flex justify-content-between">
                        <div class="d-flex align-items-center gap-4">
                          <h5 style="font-weight: 600; font-size: 16px;"
                            [ngClass]="{ 'disabled-yt-section': !isAntiTheftAndIntrusionSettingOn || showPremium}">
                            {{ "SETTINGS.Intruder" | translate }}
                          </h5>
                          <span>
                            <label class="switch"
                              [ngClass]="{ 'disabled-yt-section': !isAntiTheftAndIntrusionSettingOn || showPremium}">
                              <input type="checkbox" [(ngModel)]="isIntruderAlertOn"
                                [ngModelOptions]="{ standalone: true }"
                                (change)="onChangeIntruderAlertSettingsToggle($event)" />
                              <span class="slider round"></span>
                            </label>
                          </span>
                          <span *ngIf="showPremium"
                            [ngClass]="{ 'disabled-yt-section': !isAntiTheftAndIntrusionSettingOn}">
                            <img class="mb-2 me-2" src="./assets/images/PremiumChips.png" />
                          </span>
                        </div>
                      </div>
                      <div [ngClass]="{ 'disabled-yt-section': !isAntiTheftAndIntrusionSettingOn || showPremium}">
                        <p class="mb-0 settings-security-feature">
                          {{ "SETTINGS.INTRUDERALERTDESC" | translate }}
                        </p>
                      </div>

                      <div *ngIf="showPremium" class="set-now-banner failed-setting intruder-banner mb-3 mt-3"
                        [ngClass]="{ 'disabled-yt-section': !isAntiTheftAndIntrusionSettingOn}">
                        <div class="banner-text">
                          <span class="banner-message failed-text black">
                            {{ "SETTINGS.INTRUDERPREMIUMTEXT" | translate }}
                          </span>

                          <button class="set-now-button mt-2 mt-md-0 ms-8" (click)="navigateToRenew()"
                            style="margin-left: 125px;">
                            {{ "SETTINGS.UPGRADE" | translate }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="selctedTabType == 'DPin'" class="ml-2rem">

                    <div class="mb-4 mt-4">
                      <div class="d-flex justify-content-between">
                        <div class="d-flex align-items-center gap-3">
                          <h5 class="fw-bold">
                            {{ "MANAGEDEVICE.DEVICEPIN" | translate }}
                          </h5>
                          <span>
                            <label class="switch">
                              <input type="checkbox" [(ngModel)]="isDPinSettingOn"
                                [ngModelOptions]="{ standalone: true }" (change)="onChangeDpinSettingsToggle($event)" />
                              <span class="slider round"></span>
                            </label>
                          </span>
                        </div>
                        <div class="d-flex justify-content-between">
                          <div class="date mx-4 mb-3 ms-5" *ngIf="userName != null">
                            {{'LASTUPDATED.LASTUPDATE' | translate }} {{ dPinSyncTime }}
                          </div>
                        </div>
                      </div>
                      <div>
                        <p class="mb-0 settings-security-feature">
                          {{ 'SETTINGS.DPINDESCRIPTION' | translate }}
                        </p>
                      </div>

                      <hr style="margin-left: -32px" />

                      <div class="d-flex flex-column gap-3" [ngClass]="{ 'disabled-yt-section': !isDPinSettingOn }">
                        <div class="d-flex flex-column gap-2">
                          <div class="d-flex gap-4">
                            <div class="d-flex flex-column">
                              <form class="changepinForm" [formGroup]="changePinForm">
                                <div class="form-div">
                                  <div class="form-group mb-4" i18n-title>
                                    <label for="pin" class="q-form-label">{{ "SETTINGSMAIN.PIN" | translate }}</label>
                                    <div class="input-wrapper">
                                      <input [type]="password" onlyNumber autocomplete="off" #pinInput
                                        onKeyPress="if(this.value?.length==4) return false;" onpaste="return false;"
                                        ondrop="return false;" class="q-form-control form-control"
                                        placeholder="{{ 'SETTINGSMAIN.ENTERPIN' | translate }}" formControlName="pin"
                                        (keyup)="verifyPin()" />
                                      <div class="showpwdIcon" (click)="onClick('pin')">
                                        <img src="assets/images/hidepwd.png" alt=""
                                          *ngIf="!loginPin && f['pin'].value?.length != 0" class="cursor-pointer" />
                                        <img src="assets/images/showpwd.png" alt=""
                                          *ngIf="loginPin && f['pin'].value?.length != 0" class="cursor-pointer" />
                                      </div>
                                    </div>
                                  </div>
                                  <div class="form-group mb-0" i18n-title>
                                    <label for="confpin" class="q-form-label">{{ "SETTINGSMAIN.CONFIRMPIN" | translate
                                      }}</label>
                                    <div class="input-wrapper">
                                      <input [type]="passwords" onlyNumber autocomplete="off"
                                        class="q-form-control form-control" onpaste="return false;"
                                        ondrop="return false;" onKeyPress="if(this.value?.length==4) return false;"
                                        placeholder="{{ 'SETTINGSMAIN.REENTERPIN' | translate }}"
                                        formControlName="confirmPin" (keyup)="onFocusOut()" />
                                      <div class="showpwdIcon" (click)="onClick('confPin')">
                                        <img src="assets/images/hidepwd.png" alt=""
                                          *ngIf="!confirmpin && f['confirmPin'].value?.length != 0"
                                          class="cursor-pointer" />
                                        <img src="assets/images/showpwd.png" alt=""
                                          *ngIf="confirmpin && f['confirmPin'].value?.length != 0"
                                          class="cursor-pointer" />
                                      </div>
                                    </div>
                                    <ng-container *ngIf="pinNotMatch">
                                      <p class="errMessage" i18n-title>{{ "SETTINGSMAIN.PINDOESNTMATCH" | translate }}
                                      </p>
                                    </ng-container>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="applySection bg-white w-100 p-3 border-radius sticky-apply-buttons">
        <div class="d-flex justify-content-end"
          [ngClass]="{ 'disabled-yt-section': (pinNotMatch && selctedTabType ==='DPin') || (disableSaveButton && selctedTabType ==='Theft')}">
          <button class="cancel-btn bg-cancelbtn me-3"
            (click)="onResetBtnClick()">{{"SETTINGS.RESETTODEFAULT"|translate}}</button>
          <button class="q-form-white-submit me-3"
            (click)="saveScreenTimeSettings()">{{"SETTINGS.SAVE"|translate}}</button>
          <button class="submit-btn bg-orgclr" (click)="sendCommand()">{{"SETTINGS.APPLYSETTINGS" |
            translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Update Settings Pop Up -->
<div class="modal" id="UpdateSettingsPopup" data-bs-backdrop="static">
  <div
    class="modal-dialog opt-popup relative w-auto pointer-events-none applyOtherSettingPopWidth modal-dialog-centered">
    <div
      class="modal-content border-none rounded-25 shadow-lg applyOtherSettingPopWidth relative d-flex pt-md-4 pb-md-4  flex-column w-100 pointer-events-auto outline-none modal-dialog-centered">
      <!-- Modal Header -->
      <div class="mb-2 applyOtherSettingPopWidth">
        <h4>
          <div class="d-flex mb-4 justify-content-center">
            <span><img src="./assets/images/SuccessLock.svg" alt="" class="justify-content-center" /></span>
          </div>
          <span class="font-600-24 d-flex justify-content-center"> {{ "SETTINGS.SETTINGUPDATESENTSTRING" |
            translate }}</span>
        </h4>
      </div>

      <!-- Modal body -->
      <div class="mt-0">
        <div class="mt-1 text-400-16">
          <span> {{ "SETTINGS.APPLYTHSECHANFETOOTHER" | translate}} </span>
        </div>
        <div class="mt-1 me-2 settings-security-feature d-flex justify-content-center">
          <span> {{ "SETTINGS.NOTEFORAPPLIEDCHANGE" | translate }} </span>
        </div>
        <div class="pt-2 modal-btn-wrapper">
          <button (click)="closeupdatepopUp()" class="mt-4 mb-1 me-2 grey-backgroud w-auto submit-btn">
            {{ "SETTINGS.SKIPFORNOW" | translate }}</button>
          <button class="mt-4 mb-1 ms-4 bg-orgclr width-auto submit-btn" (click)="openselectDevicePopup()">
            {{ "SETTINGS.YES" | translate }}</button>
        </div>
      </div>
      <div class="cross-arrow-pos">
        <span><img src="./assets/images/otpCancel.svg" alt="" class="ms-xl-4" (click)="closeupdatepopUp()" /></span>

      </div>
    </div>
  </div>
</div>

<!-- Select Device PopUp -->

<div class="modal" id="selectDevicePopupPrem" data-bs-backdrop="static">
  <div
    class="modal-dialog opt-popup relative w-auto pointer-events-none applyOtherSettingPopWidth modal-dialog-centered">
    <div
      class="modal-content border-none rounded-25 shadow-lg applyOtherSettingPopWidth relative d-flex p-3 p-md-4 flex-column w-100 pointer-events-auto outline-none justify-content-start">
      <!-- Modal Header -->
      <div class="mt-0 d-flex applyOtherSettingPopWidth justify-content-start">
        <h4>
          <app-main-heading>
            <span title> {{ "SETTINGS.SELECTDEVICES" | translate }}</span>
          </app-main-heading>
        </h4>
      </div>

      <!-- Modal body -->
      <div class="mt-0">
        <form [formGroup]="deviceForm" (ngSubmit)="onApplySettingsToDevices()">
          <div class="mt-1 text-400-16">
            <span> {{ "SETTINGS.SELECTONEORMOREDEVICES" | translate }} </span>
          </div>
          <div class="mt-4 me-2 settings-security-feature">
            <div class="device-grid">
              <div class="device-card" *ngFor="let device of otherDevicePrem">
                <div class="device-info">
                  <div class="device-icon"><img src="./assets/images/MobileIcon.svg" alt="" />
                  </div>
                  <div>
                    <div class="device-text">
                      <div class="device-name" [title]="device?.deviceName">{{ device?.deviceName?.length < 18 ?
                          device?.deviceName : device?.deviceName.slice(0.15) + "..." }}</div>
                      </div>
                      <div class="user-info">
                        <span class="me-1" [title]="device?.name"><span> <img src="./assets/images/ownerUserIcon.svg"
                              alt="" class="pb-1 me-1" /></span>{{
                          device?.name?.length < 9 ? device?.name : device?.name.slice(0,8) + "..." }}</span>
                            <span class="badge ms-1" [style.color]="privacyStatusClr"
                              [style.background-color]="privacyStatusBg">{{ device.roleType | translate
                              }}</span>
                      </div>
                    </div>
                  </div>
                  <input type="checkbox" class="mb-4 accent-color" [value]="device.id"
                    (change)="onCheckboxChange($event)" />
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-center mt-3">
              <button type="button" class="mt-3 mb-1 me-2 grey-backgroud w-auto submit-btn"
                (click)="closeselectDevicepopUp()">{{
                "LOGIN.CANCEL" | translate }}</button>
              <button type="submit" [disabled]="!disableApply" class="mt-3 mb-1 ms-4 bg-orgclr width-auto submit-btn"
                [ngClass]="!disableApply ?
                            'q-invalid-button w-auto py-2 px-4'
                            : 'submit-btn bg-orgclr w-auto py-2 px-4'">{{
                "SETTINGS.APPLYSETTINGS" | translate }}</button>
            </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- Select Device PopUp -->

<div class="modal" id="selectDevicePopupFree" data-bs-backdrop="static">
  <div
    class="modal-dialog opt-popup relative w-auto pointer-events-none applyOtherSettingPopWidth modal-dialog-centered">
    <div
      class="modal-content border-none rounded-25 shadow-lg applyOtherSettingPopWidth relative d-flex p-3 p-md-4 flex-column w-100 pointer-events-auto outline-none justify-content-start">
      <!-- Modal Header -->
      <div class="mt-0 d-flex applyOtherSettingPopWidth justify-content-start">
        <h4>
          <app-main-heading>
            <span title> {{ "SETTINGS.SELECTDEVICES" | translate }}</span>
          </app-main-heading>
        </h4>
      </div>

      <!-- Modal body -->
      <div class="mt-0">
        <form [formGroup]="deviceForm" (ngSubmit)="onApplySettingsToDevices()">
          <div class="mt-1 text-400-16">
            <span> {{ "SETTINGS.SELECTONEORMOREDEVICES" | translate }} </span>
          </div>
          <div class="mt-4 me-2 settings-security-feature">
            <div class="device-grid">
              <div class="device-card" *ngFor="let device of otherDeviceFree">
                <div class="device-info">
                  <div class="device-icon"><img src="./assets/images/MobileIcon.svg" alt="" />
                  </div>
                  <div>
                    <div class="device-text">
                      <div class="device-name" [title]="device?.deviceName">{{ device?.deviceName?.length < 18 ?
                          device?.deviceName : device?.deviceName.slice(0.15) + "..." }}</div>
                      </div>
                      <div class="user-info">
                        <span class="me-1" [title]="device?.name"><span> <img src="./assets/images/ownerUserIcon.svg"
                              alt="" class="pb-1 me-1" /></span>{{
                          device?.name?.length < 9 ? device?.name : device?.name.slice(0,8) + "..." }}</span>
                            <span class="badge ms-1" [style.color]="privacyStatusClr"
                              [style.background-color]="privacyStatusBg">{{ device.roleType | translate
                              }}</span>
                      </div>
                    </div>
                  </div>
                  <input type="checkbox" class="mb-4 accent-color" [value]="device.id"
                    (change)="onCheckboxChangeFreePrompt($event)" />
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-center mt-3">
              <button type="button" class="mt-3 mb-1 me-2 grey-backgroud w-auto submit-btn"
                (click)="closeselectDevicepopUp()">{{
                "LOGIN.CANCEL" | translate }}</button>
              <button type="submit" [disabled]="!disableApply" class="mt-3 mb-1 ms-4 bg-orgclr width-auto submit-btn"
                [ngClass]="!disableApply ?
                            'q-invalid-button w-auto py-2 px-4'
                            : 'submit-btn bg-orgclr w-auto py-2 px-4'">{{
                "SETTINGS.APPLYSETTINGS" | translate }}</button>
            </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!--Settings Applied Successfully Pop up -->
<div class="modal" id="SuccessAppliedModal" data-bs-backdrop="static">
  <div
    class="modal-dialog opt-popup relative w-auto pointer-events-none applyOtherSettingPopWidth modal-dialog-centered">
    <div
      class="modal-content border-none rounded-25 shadow-lg applyOtherSettingPopWidth relative d-flex p-3 p-md-4 flex-column w-100 pointer-events-auto outline-none modal-dialog-centered">
      <!-- Modal Header -->
      <div class="mt-0 applyOtherSettingPopWidth align-items-start">
        <h4>
          <div class="d-flex mb-4 justify-content-center">
            <span><img src="./assets/images/SuccessLock.svg" alt="" class="justify-content-center" /></span>
          </div>
          <app-main-heading>
            <span title> {{ "SETTINGS.SETTINGSAPPLIEDSUCESS" | translate }}</span>
          </app-main-heading>
        </h4>
      </div>

      <!-- Modal body -->
      <div class="mt-0">
        <div class="mt-1 me-2 settings-security-feature">
          <div class="device-grid mt-3">
            <div class="device-card" *ngFor="let device of selectedDevice">
              <!-- Device Card 1 -->
              <div class="device-info">
                <div class="device-icon"><img src="./assets/images/MobileIcon.svg" alt="" />
                </div>
                <div>
                  <div class="device-text">
                    <div class="device-name" [title]="device?.deviceName">{{ device?.deviceName?.length < 18 ?
                        device?.deviceName : device?.deviceName.slice(0,15) + "..." }}</div>
                    </div>
                    <div class="user-info">
                      <span [title]="device?.name"><span> <img src="./assets/images/ownerUserIcon.svg" alt=""
                            class="pb-1 me-1" /></span>{{
                        device?.name?.length < 9 ? device?.name : device?.name.slice(0,8) + "..." }}</span>
                          <span class="badge ms-1" [style.color]="privacyStatusClr"
                            [style.background-color]="privacyStatusBg">{{ device.roleType | translate
                            }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="cross-arrow-pos">
          <span><img src="./assets/images/otpCancel.svg" alt="" class="ms-xl-4"
              (click)="closeSuccessAppliedpopUp()" /></span>

        </div>
      </div>
    </div>
  </div>

  <!-- RESET TO DEFAULT POPUP -->

  <div class="modal mx-auto fade fixed top-0 left-0 w-100 h-100 outline-none overflow-y-auto" id="resetSettingsModal"
    data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel"
    aria-hidden="true">
    <div class="modal-dialog relative w-auto pointer-events-none modal-dialog-centered text-center">
      <div class="modal-content border-none shadow-lg relative pointer-events-auto rounded-25 bg-white outline-none">
        <div class="mt-4">
          <img src="./assets/images/q-mark.png" alt="" class="mx-auto" />
        </div>
        <div>
          <h5 class="q-modal-heading mt-4 mx-5 fw-bold">
            {{ "SETTINGS.RESETLABEL" | translate }}
          </h5>
          <p class="m-2 mx-4">{{ "SETTINGS.RESETINFO" | translate }}</p>
        </div>
        <div class="text-center">
          <div class="text-lg mt-2">
            <label>{{ "SETTINGS.RESETCONFIRMATION" | translate }}</label>
          </div>
        </div>
        <div class="d-flex justify-content-center text-center">
          <div class="me-3">
            <button type="button" class="cancel-btn bg-cancelbtn mt-4 mb-4" (click)="onResetCancel()">
              {{ "SETTINGSMAIN.CANCEL" | translate }}
            </button>
          </div>
          <div>
            <button type="button" class="submit-btn bg-orgclr w-auto mt-4 mb-4" (click)="ngOnInit()">
              {{ "SETTINGS.RESETYES" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Unsaved Changes Pop Up -->
  <div class="modal" id="UnsavedSettingsPopup" data-bs-backdrop="static">
    <div
      class="modal-dialog opt-popup relative w-auto pointer-events-none applyOtherSettingPopWidth modal-dialog-centered">
      <div
        class="modal-content border-none rounded-25 shadow-lg applyOtherSettingPopWidth relative d-flex pt-md-4 pb-md-4  flex-column w-100 pointer-events-auto outline-none modal-dialog-centered">
        <div class="mt-0">
          <img src="./assets/images/q-mark.png" alt="" class="mx-auto" />
        </div>
        <!-- Modal Header -->
        <div class="mb-0 mt-0 applyOtherSettingPopWidth">
          <h4>
            <div class="d-flex mb-0 justify-content-center">
              <span><img src="./assets/images/largeQuestionMark.svg" alt="" class="justify-content-center" /></span>
            </div>
            <span class="font-600-24 d-flex justify-content-center"> {{ "SETTINGS.DESCARDCHANGES" |
              translate }}</span>
          </h4>
        </div>

        <!-- Modal body -->
        <div class="mt-0">
          <div class="mt-0 text-400-16">
            <span> {{ "SETTINGS.YOUHAVEUNSAVEDCHANGES" | translate}} </span>
          </div>
          <div class="mt-3 me-2 settings-security-feature d-flex justify-content-center">
            <span> {{ "SETTINGS.AREYOUSURETOCONTINUE" | translate }} </span>
          </div>
          <div class="pt-0 pb-3 modal-btn-wrapper">
            <button (click)="onUnsavedSettingsCancel()" class="mt-3 mb-1 me-2 grey-backgroud w-auto submit-btn">
              {{ "LOGIN.CANCEL" | translate }}</button>
            <button class="mt-3 mb-1 ms-4 bg-orgclr w-auto submit-btn" (click)="onUnsavedSettingsDiscard()">
              {{ "SETTINGS.YESDESCARD" | translate }}</button>
          </div>
        </div>
        <div class="cross-arrow-pos">
          <span><img src="./assets/images/otpCancel.svg" alt="" class="ms-xl-4"
              (click)="onUnsavedSettingsCancel()" /></span>

        </div>
      </div>
    </div>
  </div>

  <!-- Unsaved Changes Pop Up for Back button -->
  <div class="modal" id="BackUnsavedSettingsPopup" data-bs-backdrop="static">
    <div
      class="modal-dialog opt-popup relative w-auto pointer-events-none applyOtherSettingPopWidth modal-dialog-centered">
      <div
        class="modal-content border-none rounded-25 shadow-lg applyOtherSettingPopWidth relative d-flex pt-md-4 pb-md-4  flex-column w-100 pointer-events-auto outline-none modal-dialog-centered">
        <div class="mt-0">
          <img src="./assets/images/q-mark.png" alt="" class="mx-auto" />
        </div>
        <!-- Modal Header -->
        <div class="mb-0 mt-0 applyOtherSettingPopWidth">
          <h4>
            <div class="d-flex mb-0 justify-content-center">
              <span><img src="./assets/images/largeQuestionMark.svg" alt="" class="justify-content-center" /></span>
            </div>
            <span class="font-600-24 d-flex justify-content-center"> {{ "SETTINGS.DESCARDCHANGES" |
              translate }}</span>
          </h4>
        </div>

        <!-- Modal body -->
        <div class="mt-0">
          <div class="mt-0 text-400-16">
            <span> {{ "SETTINGS.YOUHAVEUNSAVEDCHANGES" | translate}} </span>
          </div>
          <div class="mt-3 me-2 settings-security-feature d-flex justify-content-center">
            <span> {{ "SETTINGS.AREYOUSURETOCONTINUE" | translate }} </span>
          </div>
          <div class="pt-0 pb-3 modal-btn-wrapper">
            <button (click)="onUnsavedSettingsCancel()" class="mt-3 mb-1 me-2 grey-backgroud w-auto submit-btn">
              {{ "LOGIN.CANCEL" | translate }}</button>
            <button class="mt-3 mb-1 ms-4 bg-orgclr w-auto submit-btn" (click)="onUnsavedSettingsDiscard()">
              {{ "SETTINGS.YESDESCARD" | translate }}</button>
          </div>
        </div>
        <div class="cross-arrow-pos">
          <span><img src="./assets/images/otpCancel.svg" alt="" class="ms-xl-4"
              (click)="onUnsavedSettingsCancel()" /></span>

        </div>
      </div>
    </div>
  </div>